const exitProps = (history) => {
  const { location: { state } } = history;

  let result = null;
  if (!state || !state.origin) {
    result = { iconType: 'close', actionType: 'redirect_home' };
  } else if (state.origin === 'dashboard') {
    result = { iconType: 'close', actionType: 'back' };
  } else {
    result = { iconType: 'back', actionType: 'back' };
  }

  return result;
};

const exitCurrentScreen = (history) => {
  if (exitProps(history).actionType === 'back') {
    history.goBack();
  } else {
    history.replace('/home');
  }
};

export default {
  exitProps,
  exitCurrentScreen,
};
